module.exports = __webpack_public_path__ + "img/horizontal_7_7_pp1_3009.62c40f95.png";